export const messages = {
  en: {
    shopBusinessTime: {
      title: 'Business Time Slots',
      shopLabel: 'Shop',
      selectShop: 'Please select shop',
      loadShopFailed: 'Failed to load shop list',
      noShop: 'No current shop info, please re-login',
      tabWeekday: 'Weekday',
      tabWeekend: 'Weekend',
      tabHoliday: 'Holiday',
      colIndex: 'No.',
      colStartTime: 'Start Time',
      colEndTime: 'End Time',
      colOperation: 'Operation',
      btnAddSlot: 'Add Slot',
      btnDelete: 'Delete',
      btnSave: 'Save',
      tipCrossMidnight: 'Tip: overnight slots (e.g. 22:00-02:00) are allowed. Overnight slots are anchored to the same day, early morning hours may be judged as closed, please configure carefully.',
      emptyText: 'No business time slots configured, click "Add Slot" below to start.',
      errIncomplete: 'Please fill in both start time and end time for every slot',
      errSameTime: 'Start time cannot equal end time',
      errOverlap: 'Business time slots within the same tab cannot overlap',
      errEmpty: 'Please keep at least one business time slot',
      confirmClear: 'No time slots across all tabs. Clearing all will delete the saved slots and restore the shop default business time. Continue?',
      clearTitle: 'Clear All Business Time Slots',
      clearConfirm: 'Clear All',
      clearCancel: 'Cancel',
      clearSuccess: 'All business time slots cleared',
      confirmDeleteTitle: 'Tip',
      confirmDeleteContent: 'Deletion cannot be undone, confirm to delete this time slot?',
      deleteSuccess: 'Deleted successfully',
      saveSuccess: 'Saved successfully',
      loadFailed: 'Failed to load business time slots',
      saveFailed: 'Failed to save'
    }
  },
  zh: {
    shopBusinessTime: {
      title: '营业时分段配置',
      shopLabel: '店铺',
      selectShop: '请选择店铺',
      loadShopFailed: '加载店铺列表失败',
      noShop: '未获取到当前店铺信息，请重新登录',
      tabWeekday: '工作日',
      tabWeekend: '周末',
      tabHoliday: '节假日',
      colIndex: '序号',
      colStartTime: '开始时间',
      colEndTime: '结束时间',
      colOperation: '操作',
      btnAddSlot: '添加时段',
      btnDelete: '删除',
      btnSave: '保存',
      tipCrossMidnight: '提示：允许配置跨零点时段（如 22:00-02:00）；跨零点时段按当天锚定判定，凌晨段可能被判定为休息，请合理配置。',
      emptyText: '暂无营业时段配置，点击下方「添加时段」开始配置。',
      errIncomplete: '请完整填写每个时段的开始时间和结束时间',
      errSameTime: '开始时间不能等于结束时间',
      errOverlap: '同一页签内营业时段不能重叠',
      errEmpty: '请至少保留一个营业时段',
      confirmClear: '三个页签均未配置时段，清空将删除已保存的全部营业时段并恢复店铺默认营业时间，是否继续？',
      clearTitle: '清空全部营业时段',
      clearConfirm: '确认清空',
      clearCancel: '取消',
      clearSuccess: '已清空全部营业时段',
      confirmDeleteTitle: '提示',
      confirmDeleteContent: '删除后不可恢复，确认删除该时段吗？',
      deleteSuccess: '删除成功',
      saveSuccess: '保存成功',
      loadFailed: '加载营业时段配置失败',
      saveFailed: '保存失败'
    }
  }
}
